import { useCallback, useEffect, useRef, useState } from 'react'
import useAxiosPrivate from './useAxiosPrivate'
import socket from '../utils/socket'
import { subscribeAttachmentOpened } from '../utils/attachmentEvents'

// How many readable documents sent to me are still unopened ("new"), across all chats.
const useUnreadDocs = (enabled) => {
  const axiosPrivate = useAxiosPrivate()
  const [count, setCount] = useState(0)
  const timerRef = useRef(null)

  const load = useCallback(async () => {
    try {
      const { data } = await axiosPrivate.get('/api/messages/attachments/unread-count')
      setCount(Number(data?.count) || 0)
    } catch (err) {
      if (err?.name !== 'CanceledError' && err?.name !== 'AbortError') {
        console.error('Unable to load new documents', err)
      }
    }
  }, [axiosPrivate])

  // Several events can arrive together: reload once, shortly after the last one
  const scheduleLoad = useCallback(() => {
    clearTimeout(timerRef.current)
    timerRef.current = setTimeout(load, 400)
  }, [load])

  useEffect(() => {
    if (!enabled) {
      setCount(0)
      return
    }

    load()

    socket.on('newMessage', scheduleLoad)
    socket.on('connect', scheduleLoad)
    const unsubscribe = subscribeAttachmentOpened(scheduleLoad)
    const poll = setInterval(load, 60000)    // safety net

    return () => {
      clearTimeout(timerRef.current)
      clearInterval(poll)
      socket.off('newMessage', scheduleLoad)
      socket.off('connect', scheduleLoad)
      unsubscribe()
    }
  }, [enabled, load, scheduleLoad])

  return count
}

export default useUnreadDocs
